import ChatEvents from "./ChatEvents"
import GeneralEvents from "./GeneralEvents"
import QuizEvents from "./QuizEvents"

export const EventsList = {
    ...GeneralEvents,
    ...QuizEvents,
    ...ChatEvents
}
